/**
 * @generated SignedSource<<5c8d2e7dbfee7919683f7d0d82dce752>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MATConsultationHistoryCreateDialog_SalesRecordTitleLabel_oraganizationQuery$variables = {
  id: string;
};
export type MATConsultationHistoryCreateDialog_SalesRecordTitleLabel_oraganizationQuery$data = {
  readonly salesRecord: {
    readonly id: string;
    readonly title: string;
  };
};
export type MATConsultationHistoryCreateDialog_SalesRecordTitleLabel_oraganizationQuery = {
  response: MATConsultationHistoryCreateDialog_SalesRecordTitleLabel_oraganizationQuery$data;
  variables: MATConsultationHistoryCreateDialog_SalesRecordTitleLabel_oraganizationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "MATSalesRecord",
    "kind": "LinkedField",
    "name": "salesRecord",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MATConsultationHistoryCreateDialog_SalesRecordTitleLabel_oraganizationQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MATConsultationHistoryCreateDialog_SalesRecordTitleLabel_oraganizationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "254f51712de454c901c327a459b4e207",
    "id": null,
    "metadata": {},
    "name": "MATConsultationHistoryCreateDialog_SalesRecordTitleLabel_oraganizationQuery",
    "operationKind": "query",
    "text": "query MATConsultationHistoryCreateDialog_SalesRecordTitleLabel_oraganizationQuery(\n  $id: ID!\n) {\n  salesRecord(id: $id) {\n    id\n    title\n  }\n}\n"
  }
};
})();

(node as any).hash = "c2382057792d79619ff4d1e2f1b9db77";

export default node;
